// extracted by mini-css-extract-plugin
module.exports = {"svg":"svg-icon_svg_hS3Hh"};